
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/ckan/consultancy",
      function () {
        return require("private-next-pages/solutions/ckan/consultancy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/ckan/consultancy"])
      });
    }
  